export default {
    entityTagPicker_untagged: "Untagged",
    entityTagPicker_noMore: "No more items",
    entityTagPicker_noFound: "No items found", 
    entityTagPicker_includeUnassigned: "Include unassigned drivers"
};